import SplineChart from "./components/SplineChart";

function DashboardPage() {
  return (
    <div className="p-4">
      <div className="max-w-7xl mx-auto space-y-8">
        <SplineChart />
      </div>
    </div>
  );
}

export default DashboardPage;
